exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-product-item{display:flex;flex-direction:column;margin:1rem;width:350px}.ai-product-item__title-container{height:7rem;display:flex;justify-content:center;align-items:center;width:350px}.ai-product-item__button{display:flex;justify-content:center;align-items:center;width:100%;height:86px;border-radius:1rem;background-color:#FF4A00;border-right:2px solid white;border-bottom:2px solid white;cursor:pointer}.ai-product-item .ai-product-item__pic{width:350px;height:300px;padding:.5rem;box-sizing:border-box;background-position:center;background-size:cover}.ai-product-item .ai-product-item__title{text-align:center;width:70%;font-size:1rem;color:white}@media (min-width: 300px) and (max-width: 700px){.ai-product-item{width:320px}.ai-product-item .ai-product-item__pic{width:320px}.ai-product-item__title-container{width:320px}.ai-product-item__button{width:320px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/product-item/product-item.style.scss
// module id = 212
// module chunks = 0